import { useEffect } from 'react'
import './err404.scss';
import { Link } from 'react-router-dom';

export default function Err404({ setPageTitle }: any) {

  // Nombre de la página
  const namePage = 'Página no encontrada';

  useEffect(() => {

    // Titulos de pagina
    setPageTitle(namePage);
    document.title = namePage;

  }, []);

  return (
    <section className='content_page_error'>
      <div className='page_error'>

        <div className='title_element'>
          <span className='title'>404</span>
          <span className='divisor'>|</span>
          <span className='subtitle'>PÁGINA NO ENCONTRADA</span>
        </div>

        <div className='description_element'>
          <span>No se ha podido encontrar la página que busca. Por favor, compruebe el enlace/URL o intente empezar de nuevo desde nuestra <Link to="/">página de inicio</Link>.</span>
        </div>

      </div>
    </section>
  )
}
